import React from 'react'
import { inject,observer } from 'mobx-react'

import Stepper, { Step, StepLabel, StepContent, StepButton } from 'material-ui/Stepper'
import Slide from 'material-ui/transitions/Slide'
import Dialog from 'material-ui/Dialog'
import T from 'i18n-react'
import Input, { InputLabel } from 'material-ui/Input'
import TextField from 'material-ui/TextField'
import { MenuItem } from 'material-ui/Menu'
import { FormControl, FormHelperText } from 'material-ui/Form'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import IconButton from 'material-ui/IconButton'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import { Link } from 'react-router-dom'
import Grid from 'material-ui/Grid'
import Select from 'material-ui/Select'
import Avatar from 'material-ui/Avatar'
import Divider from 'material-ui/Divider'
import { indigo } from 'material-ui/colors'
import Chip from 'material-ui/Chip'
import { findDOMNode } from 'react-dom'
import Dropzone from 'react-dropzone'
import ButtonBase from 'material-ui/ButtonBase'


@inject('newcollectionformstore','ui','store') @observer
class NewCollectionForm extends React.Component {
  render () {
    const ui = this.props.ui.newCollectionForm
    const {
      classes,
      label,
      asSuggestion,
      asUpdate,
      asAcceptDecline,
      asDeleteRestore,
      sendSuggestion,
      sendAccept,
      sendDecline,
      sendUpdate,
      sendPermDelete,
      sendRestore
    } = this.props

    return (
      <Dialog
       fullScreen
       open={ui.open}
      >
       <NewExampleFormHeader
        classes={classes}
        label={label}
        asSuggestion={asSuggestion}
        asUpdate={asUpdate}
        asAcceptDecline={asAcceptDecline}
        asDeleteRestore={asDeleteRestore}
        sendSuggestion={sendSuggestion}
        sendAccept={sendAccept}
        sendDecline={sendDecline}
        sendUpdate={sendUpdate}
        sendPermDelete={sendPermDelete}
        sendRestore={sendRestore}
       />
     </Dialog>
    )
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.exampleids) {
      this.props.newcollectionformstore.setExampleids(nextProps.exampleids)
    }
    if (nextProps.collection) {
      this.props.newcollectionformstore.injectCollection(nextProps.collection)
    }
  }
}

@inject('newcollectionformstore','ui','messenger') @observer
class NewExampleFormHeader extends React.Component {
  constructor (props) {
    super(props)

    this.store = this.props.newcollectionformstore

    this.sendSuggestion = this.sendSuggestion.bind(this)
    this.sendAccept = this.sendAccept.bind(this)
    this.sendDecline = this.sendDecline.bind(this)
    this.sendUpdate = this.sendUpdate.bind(this)
    this.sendPermDelete = this.sendPermDelete.bind(this)
    this.sendRestore = this.sendRestore.bind(this)
  }

  render () {
    const {
      classes,
      label,
      asSuggestion,
      asUpdate,
      asAcceptDecline,
      asDeleteRestore
     } = this.props,
    ui = this.props.ui.newCollectionForm

    let actions = null
    if (asSuggestion) {
      actions = <Button dense color="inherit" onClick={this.sendSuggestion} key={"suggest-example"}>
       {T.translate("newexampleform.sendSuggestion")}
      </Button>
    }
    if (asAcceptDecline) {
      actions = [
       <Button dense color="inherit" onClick={this.sendDecline} key={"decline-example"}>
        <Icon>thumb_down</Icon>
        <span style={{paddingLeft:5}}>{T.translate("newexampleform.decline")}</span>
       </Button>,
       <Button dense color="inherit" onClick={this.sendAccept} key={"accept-example"}>
        <Icon>thumb_up</Icon>
        <span style={{paddingLeft:5}}>{T.translate("newexampleform.accept")}</span>
       </Button>
      ]
    }
    if (asUpdate) {
      actions = <Button color="inherit" onClick={this.sendUpdate}>
       {T.translate("newexampleform.update")}
      </Button>
    }
    if (asDeleteRestore) {
      actions = [
       <Button dense color="inherit" onClick={this.sendPermDelete} key={"perm-delete-collection"}>
        <Icon>thumb_down</Icon>
        <span style={{paddingLeft:5}}>{T.translate("newexampleform.permDelete")}</span>
       </Button>,
       <Button dense color="inherit" onClick={this.sendRestore} key={"restore-collection"}>
        <Icon>thumb_up</Icon>
        <span style={{paddingLeft:5}}>{T.translate("newexampleform.restore")}</span>
       </Button>
      ]
    }

    return (
      <div className={classes.root}>
        <AppBar className={classes.appBar}>
         <Toolbar>
          <IconButton
           color="inherit"
           onClick={ui.handleClose}
           aria-label="Close"
          > <Icon>close</Icon> </IconButton>
          <div className={classes.flex} />
          <Link to={this.store.relativeCollectionLink} className="unstyle-a">
           <Button color="inherit">
           <Icon>remove_red_eye</Icon>
           <span style={{paddingLeft:5}}>{T.translate('newcollectionform.watchCollection')}</span>
           </Button>
          </Link>
          {actions}
         </Toolbar>
        </AppBar>
        <NewCollectionFormContent
         classes={classes}
         label={label}
        />
      </div>
    )
  }

  sendSuggestion () {
    const payload = this.props.newcollectionformstore.getPayload()
    this.props.sendSuggestion(payload, (res) => {
      if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_SUCCESS)
      }
      this.props.ui.newCollectionForm.handleClose()
    })
  }

  sendAccept () {
    const payload = this.props.newcollectionformstore.getPayload()
    this.props.sendAccept(payload, (res) => {
      if (res.success) {
        this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_ACCEPTED)
      }
      this.props.ui.newCollectionForm.handleClose()
    })
  }

  sendDecline () {
    const payload = this.props.newcollectionformstore.getPayload()
    this.props.sendDecline(payload.id, (res) => {
      if (res.success) {
        this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_DECLINED)
      }
      this.props.ui.newCollectionForm.handleClose()
    })
  }

  sendUpdate () {
    const payload = this.props.newcollectionformstore.getPayload()
    this.props.sendUpdate(payload, (res) => {
      if (res.success) {
        this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
      }
      this.props.ui.newCollectionForm.handleClose()
    })
  }

  sendPermDelete () {
    const payload = this.props.newcollectionformstore.getPayload()
    this.props.sendPermDelete(payload.id, (res) => {
      if (res.success) {
        this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_PERM_DELETED)
      }
      this.props.ui.newCollectionForm.handleClose()
    })
  }

  sendRestore () {
    const payload = this.props.newcollectionformstore.getPayload()
    this.props.sendRestore(payload.id, (res) => {
      if (res.success) {
        this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_RESTORED)
      }
      this.props.ui.newCollectionForm.handleClose()
    })
  }

}


@inject('store','newcollectionformstore','ui') @observer
class NewCollectionFormContent extends React.Component {
  constructor (props) {
    super(props)

    this.store = this.props.newcollectionformstore
    this.ui = this.props.ui.newCollectionForm

    this.setTitle = this.setTitle.bind(this)
    this.setDescription = this.setDescription.bind(this)
    this.setContact = this.setContact.bind(this)
  }

  render () {
   const { classes,label } = this.props, store = this.store

    return (
     <div className={classes.content}>
      <Grid container direction="row" justify="center" alignItems="flex-start" spacing={Number(8)}>
      <Grid item xs={12} className="center-text">
       <Typography type="title"> {label} </Typography>
      </Grid>
       <Grid item xs={12} sm={8} md={6}>

       <TextField
        autoFocus
        margin="dense"
        id="publish-title"
        label={T.translate('cart.publishTitle')}
        type="text"
        value={store.title}
        onChange={this.setTitle}
        fullWidth
       />

       <TextField
        margin="dense"
        id="publish-description"
        multiline
        rows={3}
        label={T.translate('cart.publishDescription')}
        type="text"
        value={store.description}
        onChange={this.setDescription}
        fullWidth
       />

       <Typography component="p" type="caption"> {T.translate("newexampleform.contact")} </Typography>
       <TextField
        id="contact"
        placeholder={T.translate("newexampleform.stepContact")}
        value={store.contact}
        onChange={this.setContact}
        fullWidth
       />

       </Grid>
      </Grid>
     </div>
    )
  }

  setTitle (e) {
    this.store.setTitle(e.target.value)
  }

  setDescription (e) {
    this.store.setDescription(e.target.value)
  }

  setContact (e) {
    this.store.setContact(e.target.value)
  }

}




const styles = theme => ({
  root: {
   width: '100%',
   height:'100vh',
   zIndex: 1,
   overflow: 'hidden',
  },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  content: {
   width: '100%',
   overflow:'auto',
   'overflow-x':'hidden',
   flexGrow: 1,
   paddingLeft:10,
   paddingRight:10,
   backgroundColor: theme.palette.background.default,
   transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
   }),
   height: 'calc(100% - 56px - 48px)',
   marginTop: 56 + 48,
   [theme.breakpoints.up('sm')]: {
     height: 'calc(100% - 64px - 48px)',
    marginTop: 64 + 48,
   },
  },
  formControl: {
   margin: theme.spacing.unit,
   width: "100%",
  },
  background:{
    width:"100%",
    backgroundRepeat:"no-repeat",
    backgroundSize:"cover",
    backgroundPosition:"center center",
    cursor:"pointer"
  },
  thumbnailContainer:{
    marginTop:10,
    marginBottom:10
  },
  thumbnail:{
    minHeight:45
  },
  flex: {
    flex: 1,
  }
})


export default withStyles(styles, { withTheme: true })(NewCollectionForm)



// WEBPACK FOOTER //
// ./src/components/newcollectionform.js